import { z } from 'zod';

/**
 * Zod validation schema for addresses.
 */
export const AddressModel = z.object({
  buildingNumber: z.union([z.string().trim(), z.literal('')]).nullish(),
  city: z.union([z.string().trim(), z.literal('')]).nullish(),
  country: z.union([z.string().trim(), z.literal('')]).nullish(),
  postCode: z.union([z.string().trim(), z.literal('')]).nullish(),
  streetName: z.union([z.string().trim(), z.literal('')]).nullish(),
});
